import LibDateTime from "../../util/libDateTime";

export const PRAZO_AVISO_CONTINGENCIA = 3;

export const PENDENCIAS = {
	REJEITADA: { rotulo: "Rejeitada", tom: "vermelho", acoes: ["corrigir", "reenviar", "baixarXml"] },
	CONTINGENCIA: {
		rotulo: "Contingência",
		tom: "ambar",
		acoes: ["transmitir", "consultar", "imprimir", "baixarXml"],
	},
	CONT_REJEITADA: {
		rotulo: "Contingência rejeitada",
		tom: "vermelho",
		acoes: ["consultar", "imprimir", "baixarXml"],
	},
	AGUARDANDO_ENVIO: { rotulo: "Aguardando envio", tom: "ambar", acoes: ["transmitir", "consultar"] },
	ERRO_TRANSMISSAO: { rotulo: "Erro de transmissão", tom: "vermelho", acoes: ["reenviar", "consultar"] },
	CANCELAMENTO_PENDENTE: { rotulo: "Cancelamento pendente", tom: "ambar", acoes: ["consultar", "cancelar"] },
	ERRO_CANCELAMENTO: { rotulo: "Erro no cancelamento", tom: "vermelho", acoes: ["consultar", "cancelar"] },
	VENDA_SEM_DOCUMENTO: { rotulo: "Venda sem documento", tom: "ambar", acoes: ["emitir"], abrir: "venda" },
	DOCUMENTO_SEM_VENDA: { rotulo: "Documento sem venda", tom: "ambar", acoes: ["corrigir", "consultar", "cancelar"] },
	FALHA_SEQUENCIA: { rotulo: "Falha de sequência", tom: "vermelho", acoes: [], abrir: "analisar" },
	VENDA_CANCELADA_DOC_ATIVO: { rotulo: "Venda cancelada, nota ativa", tom: "vermelho", acoes: ["cancelar", "consultar"] },
	DOC_CANCELADO_VENDA_ATIVA: { rotulo: "Nota cancelada, venda ativa", tom: "ambar", acoes: [] },
	DOCUMENTOS_DUPLICADOS: { rotulo: "Documento duplicado", tom: "vermelho", acoes: ["consultar", "cancelar"] },
	VINCULO_INCORRETO: { rotulo: "Vínculo incorreto", tom: "ambar", acoes: ["corrigir", "consultar"] },
};

export const CARDS = [
	{ chave: "contingencia", rotulo: "Em contingência", tom: "ambar", tipos: ["CONTINGENCIA", "CONT_REJEITADA"] },
	{ chave: "rejeitadas", rotulo: "Rejeitadas", tom: "vermelho", tipos: ["REJEITADA"] },
	{
		chave: "transmissao",
		rotulo: "Aguardando transmissão",
		tom: "ambar",
		tipos: ["AGUARDANDO_ENVIO", "ERRO_TRANSMISSAO"],
	},
	{
		chave: "cancelamento",
		rotulo: "Cancelamento com problema",
		tom: "vermelho",
		tipos: ["CANCELAMENTO_PENDENTE", "ERRO_CANCELAMENTO"],
	},
	{ chave: "vendaSemDocumento", rotulo: "Vendas sem documento", tom: "ambar", tipos: ["VENDA_SEM_DOCUMENTO"] },
	{ chave: "documentoSemVenda", rotulo: "Documentos sem venda", tom: "ambar", tipos: ["DOCUMENTO_SEM_VENDA"] },
	{ chave: "sequencia", rotulo: "Falhas de sequência", tom: "vermelho", tipos: ["FALHA_SEQUENCIA"] },
	{
		chave: "outras",
		rotulo: "Outras pendências",
		tom: "ambar",
		tipos: ["VENDA_CANCELADA_DOC_ATIVO", "DOC_CANCELADO_VENDA_ATIVA", "DOCUMENTOS_DUPLICADOS", "VINCULO_INCORRETO"],
	},
];

export function diasEmContingencia(pendencia) {
	return pendencia.tipo === "CONTINGENCIA" ? LibDateTime.diasDesdeDelphi(pendencia.data_emissao) : 0;
}

export function acaoDetalhe(pendencia) {
	return pendencia.id_nota_fiscal ? "visualizar" : PENDENCIAS[pendencia.tipo].abrir;
}
